export default {
  name: "CaptureTypeModal",
  props: ["data", "onClose"],
  data() {
    return {
      open: true
    };
  },
  mounted() {},
  methods: {
    close: function(data) {
      this.onClose(data);
    }
  }
};
